import Operation from './Operation';

export default class Power extends Operation {
  cal (a, b) {
    return Math.pow(a, b);
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/Power.js